<app-admin-page-header
  eyebrow="Communauté"
  title="Utilisateurs"
  subtitle="Gestion des membres inscrits et des inscriptions manuelles aux événements.">
  <button (click)="openInscriptionModal()" type="button"
    class="inline-flex items-center gap-2 px-4 py-2 bg-primary text-white text-sm font-raleway font-semibold rounded-lg hover:bg-secondary transition-colors shadow-sm">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
    </svg>
    Inscrire à un événement
  </button>
</app-admin-page-header>

<!-- Stats -->
<div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
    <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Total</p>
    <p class="text-3xl font-alice text-blue-dark mt-1">{{ utilisateurs.length }}</p>
    <p class="text-xs text-gray-500 mt-1">Membres inscrits</p>
  </div>
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
    <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Administrateurs</p>
    <p class="text-3xl font-alice text-blue-dark mt-1">{{ adminCount }}</p>
    <p class="text-xs text-gray-500 mt-1">Comptes avec droits admin</p>
  </div>
  <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm">
    <p class="text-xs uppercase tracking-wider font-semibold text-gray-400">Affichés</p>
    <p class="text-3xl font-alice text-blue-dark mt-1">{{ filteredUtilisateurs.length }}</p>
    <p class="text-xs text-gray-500 mt-1">Filtre actif</p>
  </div>
</div>

<!-- Table -->
<div class="bg-white rounded-xl border border-gray-200 shadow-sm">
  <div class="px-5 py-4 border-b border-gray-100">
    <div class="relative max-w-md">
      <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
        <svg class="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
        </svg>
      </div>
      <input type="search" [(ngModel)]="search" placeholder="Rechercher par nom, prénom, email..."
        class="w-full pl-10 pr-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
      </div>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full text-sm font-raleway">
        <thead class="bg-gray-50">
          <tr>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">
              <button class="inline-flex items-center gap-1 hover:text-primary" (click)="toggleSort('lastName')">
                Membre
                <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4"/></svg>
              </button>
            </th>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">
              <button class="inline-flex items-center gap-1 hover:text-primary" (click)="toggleSort('email')">Email</button>
            </th>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">
              <button class="inline-flex items-center gap-1 hover:text-primary" (click)="toggleSort('role')">Rôle</button>
            </th>
            <th class="text-left px-5 py-3 text-[11px] uppercase tracking-wider font-semibold text-gray-500">Statut</th>
            <th class="px-5 py-3"></th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-100">
          @for (u of filteredUtilisateurs; track u) {
            <tr class="hover:bg-gray-50 transition-colors" [class.opacity-60]="u.disabled">
              <td class="px-5 py-3">
                <div class="flex items-center gap-3">
                  <div class="w-9 h-9 rounded-full bg-gradient-to-br from-primary to-secondary text-white flex items-center justify-center font-raleway font-semibold text-xs shrink-0">
                    {{ initials(u) }}
                  </div>
                  <div class="min-w-0">
                    <p class="font-semibold text-gray-800 truncate">{{ u.lastName }} {{ u.firstName }}</p>
                    @if (isSelf(u)) {
                      <p class="text-[11px] text-gray-400">Vous</p>
                    }
                  </div>
                </div>
              </td>
              <td class="px-5 py-3 text-gray-600">
                <a [href]="'mailto:' + u.email" class="hover:text-primary">{{ u.email }}</a>
              </td>
              <td class="px-5 py-3">
                @if (u.role === 'admin') {
                  <span class="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-primary/10 text-primary text-[11px] font-semibold uppercase tracking-wider">
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>
                    Admin
                  </span>
                }
                @if (u.role !== 'admin') {
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 text-[11px] font-semibold uppercase tracking-wider">
                    Membre
                  </span>
                }
              </td>
              <td class="px-5 py-3">
                @if (u.disabled) {
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-red-100 text-red-700 text-[11px] font-semibold uppercase tracking-wider">
                    Désactivé
                  </span>
                }
                @if (!u.disabled) {
                  <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 text-[11px] font-semibold uppercase tracking-wider">
                    Actif
                  </span>
                }
              </td>
              <td class="px-5 py-3">
                @if (!isSelf(u)) {
                  <div class="flex items-center justify-end gap-2">
                    <button type="button" (click)="requestToggleRole(u)"
                      class="px-2.5 py-1 text-xs font-raleway font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 whitespace-nowrap">
                    {{ u.role === 'admin' ? 'Retirer admin' : 'Rendre admin' }}
                  </button>
                  <button type="button" (click)="requestToggleDisabled(u)"
                    class="px-2.5 py-1 text-xs font-raleway font-semibold rounded-lg border whitespace-nowrap"
                    [class.text-red-600]="!u.disabled" [class.border-red-200]="!u.disabled" [class.hover:bg-red-50]="!u.disabled"
                    [class.text-emerald-600]="u.disabled" [class.border-emerald-200]="u.disabled" [class.hover:bg-emerald-50]="u.disabled">
                    {{ u.disabled ? 'Réactiver' : 'Désactiver' }}
                  </button>
                </div>
              } @else {
                <p class="text-right text-[11px] text-gray-400 italic">Non modifiable</p>
              }
            </td>
          </tr>
        }
        @if (filteredUtilisateurs.length === 0) {
          <tr>
            <td colspan="5" class="px-5 py-10 text-center text-sm text-gray-400">
              @if (search) {
                <span>Aucun utilisateur ne correspond à « {{ search }} ».</span>
              }
              @if (!search) {
                <span>Aucun utilisateur inscrit.</span>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>

<!-- Confirm role/status change modal -->
@if (isConfirmModalOpen) {
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex items-end sm:items-center justify-center min-h-screen px-4 py-6">
      <div (click)="closeConfirmModal()" class="fixed inset-0 bg-gray-900/60 transition-opacity" aria-hidden="true"></div>
      <div class="relative bg-white rounded-2xl shadow-xl w-full max-w-md">
        <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div>
            <p class="text-[10px] font-raleway uppercase tracking-widest text-primary/70">Confirmation</p>
            <h3 class="text-lg font-alice text-blue-dark">{{ confirmModalTitle }}</h3>
          </div>
          <button (click)="closeConfirmModal()" type="button" class="p-2 rounded-md text-gray-400 hover:bg-gray-100">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
        </div>
        <div class="px-6 py-5">
          <p class="text-sm font-raleway text-gray-600">{{ confirmModalMessage }}</p>
        </div>
        <div class="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 px-6 pb-6">
          <button type="button" (click)="closeConfirmModal()"
            class="px-4 py-2 text-sm font-raleway font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
            Annuler
          </button>
          <button type="button" (click)="confirmPendingAction()" [disabled]="isConfirming"
            class="px-4 py-2 text-sm font-raleway font-semibold text-white bg-primary rounded-lg hover:bg-secondary disabled:opacity-50 disabled:cursor-not-allowed">
            {{ isConfirming ? 'Enregistrement…' : 'Confirmer' }}
          </button>
        </div>
      </div>
    </div>
  </div>
}

<!-- Inscription Modal -->
@if (isInscriptionModalOpen) {
  <div class="fixed inset-0 z-50 overflow-y-auto">
    <div class="flex items-end sm:items-center justify-center min-h-screen px-4 py-6">
      <div (click)="closeInscriptionModal()" class="fixed inset-0 bg-gray-900/60 transition-opacity" aria-hidden="true"></div>
      <div class="relative bg-white rounded-2xl shadow-xl w-full max-w-md">
        <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div>
            <p class="text-[10px] font-raleway uppercase tracking-widest text-primary/70">Action</p>
            <h3 class="text-lg font-alice text-blue-dark">Inscrire un membre à un événement</h3>
          </div>
          <button (click)="closeInscriptionModal()" type="button" class="p-2 rounded-md text-gray-400 hover:bg-gray-100">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
          </button>
        </div>
        <form [formGroup]="inscriptionForm" (ngSubmit)="validate()" class="px-6 py-5 flex flex-col gap-4">
          <div>
            <label for="evenement_key" class="block mb-1.5 text-sm font-raleway font-semibold text-gray-700">Événement</label>
            <select formControlName="evenement_key" id="evenement_key"
              class="w-full px-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
              <option value="" disabled>Sélectionner un événement…</option>
              @for (e of evenements; track e) {
                <option [value]="e.key">{{ e.nom }}</option>
              }
            </select>
          </div>
          <div>
            <label for="utilisateur_uid" class="block mb-1.5 text-sm font-raleway font-semibold text-gray-700">Utilisateur</label>
            <select formControlName="utilisateur_uid" id="utilisateur_uid"
              class="w-full px-3 py-2 text-sm font-raleway bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary">
              <option value="" disabled>Sélectionner un utilisateur…</option>
              @for (u of utilisateurs; track u) {
                <option [value]="u.uid">{{ u.lastName }} {{ u.firstName }}</option>
              }
            </select>
          </div>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" id="is_present" formControlName="is_present"
              class="h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary/30">
              <span class="text-sm font-raleway text-gray-700">Sera présent.e à l'événement</span>
            </label>
            <div class="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 pt-2">
              <button type="button" (click)="closeInscriptionModal()"
                class="px-4 py-2 text-sm font-raleway font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50">
              Annuler
            </button>
            <button type="submit" [disabled]="inscriptionForm.invalid || isSubmitting"
              class="px-4 py-2 text-sm font-raleway font-semibold text-white bg-primary rounded-lg hover:bg-secondary disabled:opacity-50 disabled:cursor-not-allowed">
              {{ isSubmitting ? 'Enregistrement…' : 'Valider' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
}

<app-toast></app-toast>
